/* eslint-disable
    goodeggs/lodash-matches-prop-shorthand,
    goodeggs/lodash-matches-shorthand,
    goodeggs/lodash-prefer-immutable-method,
    goodeggs/lodash-preferred-alias,
    goodeggs/lodash-prop-shorthand,
    no-alert,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'lodash';

import {BigNumber} from 'bignumber.js';
import catalogEnums from 'goodeggs-purchase-orders-sdk/catalog/enums';
import helpers from 'goodeggs-purchase-orders-sdk/catalog/helpers';
import foodhubHelpers from 'goodeggs-purchase-orders-sdk/foodhub/helpers';
import * as sites from 'goodeggs-sites';

export default ngInject(function(
  $http,
  $rootScope,
  $scope,
  $stateParams,
  $state,
  $window,
  toaster,
  foodhub,
  Producer,
  Supplier,
  Catalog,
  ProcurementSchedule,
  Product,
  ProductTypes,
  employeeRoles,
  externalUrls,
  settings,
  KlaxonAlert,
  Promise,
  shouldMigrateToRiversand,
  getCatalogProductStructureType,
) {
  this.loading = true;

  this.storeByValues = [];
  this.comparisonUnitIsRange = null;

  let _oldPackagedItemQuantity = null;

  let _oldComparisonUnit = null;

  $scope.$watch('ctrl.comparisonUnitIsRange', (value, oldValue) => {
    if (oldValue == null || this.catalogItem == null) {
      return;
    }
    if (value) {
      return (this.catalogItem.comparisonUnitMaxQuantity =
        _oldComparisonUnit != null ? _oldComparisonUnit.maxQuantity : undefined);
    }
    _oldComparisonUnit = {maxQuantity: this.catalogItem.comparisonUnitMaxQuantity};
    return delete this.catalogItem.comparisonUnitMaxQuantity;
  });

  $scope.$watch('ctrl.catalogItem.packagingFormat', (value, oldValue) => {
    if (oldValue == null || this.catalogItem == null) {
      return;
    }
    if (_.isEmpty(value)) {
      _oldPackagedItemQuantity = this.catalogItem.packagedItemQuantity;
      return delete this.catalogItem.packagedItemQuantity;
    } else if (!oldValue) {
      return (this.catalogItem.packagedItemQuantity = _oldPackagedItemQuantity);
    }
  });

  $scope.$watch('ctrl.storeBy', (value, oldValue) => {
    if (oldValue == null || this.catalogItem == null) {
      return;
    }
    if (value === 'each') {
      this.catalogItem.storeByEach = true;
      this.catalogItem.comparisonUnitName =
        _oldComparisonUnit != null ? _oldComparisonUnit.name : undefined;
      this.catalogItem.comparisonUnitMinQuantity =
        (_oldComparisonUnit != null ? _oldComparisonUnit.minQuantity : undefined) != null
          ? _oldComparisonUnit != null
            ? _oldComparisonUnit.minQuantity
            : undefined
          : 1;
      this.catalogItem.comparisonUnitMaxQuantity =
        _oldComparisonUnit != null ? _oldComparisonUnit.maxQuantity : undefined;
      return (this.comparisonUnitIsRange = Boolean(this.catalogItem.comparisonUnitMaxQuantity));
    }
    if (this.catalogItem.storeByEach) {
      _oldComparisonUnit = {
        name: this.catalogItem.comparisonUnitName,
        minQuantity: this.catalogItem.comparisonUnitMinQuantity,
        maxQuantity: this.catalogItem.comparisonUnitMaxQuantity,
      };
    }
    this.catalogItem.storeByEach = false;
    this.catalogItem.comparisonUnitName = value;
    this.catalogItem.comparisonUnitMinQuantity = undefined;
    return (this.catalogItem.comparisonUnitMaxQuantity = undefined);
  });

  $scope.$watchGroup(
    [
      'ctrl.catalogItem.storeByEach',
      'ctrl.catalogItem.comparisonUnitName',
      'ctrl.catalogItem.comparisonUnitMinQuantity',
      'ctrl.catalogItem.comparisonUnitMaxQuantity',
      'ctrl.catalogItem.packagingFormat',
      'ctrl.catalogItem.packagedItemQuantity',
    ],
    () =>
      this.catalogItem != null
        ? (this.catalogItem.unitLabel = helpers.computeCanonicalUnit(
            this.catalogItem != null ? this.catalogItem : {},
          ))
        : undefined,
  );

  this.marketplaceAvailabilityDetailsLink = (marketProductId) =>
    externalUrls.getAvailabilityUrl($stateParams.foodhubSlug, marketProductId);

  // Clone from... functionality
  this.cloneChoice = null;

  this.searchCloneableCatalogItems = (namePrefix) =>
    Catalog.query({search: namePrefix, $limit: 10}).$promise;

  this.getCloneFromLabel = function(catalogItem) {
    if (catalogItem == null) {
      return '';
    }

    return `${catalogItem.name} (${
      catalogItem.vendor != null ? catalogItem.vendor.name : undefined
    })`;
  };

  this.cloneFromCloneChoice = () => {
    if (this.cloneChoice == null) {
      return;
    }

    const cloneableProps = _.pick(this.cloneChoice, [
      'name',
      'unitQuantityLabel',
      'unitQuantity',
      'storeByEach',
      'comparisonUnitName',
      'comparisonUnitMinQuantity',
      'comparisonUnitMaxQuantity',
      'packagingFormat',
      'packagedItemQuantity',
      'irlYield',
      'isProduce',
      'needsPrep',
      'fungible',
    ]);
    _.extend(this.catalogItem, cloneableProps);
    this.storeBy = (this.catalogItem.storeByEach && 'each') || this.catalogItem.comparisonUnitName;
    _oldPackagedItemQuantity = null;
    if (this.catalogItem.storeByEach) {
      _oldComparisonUnit = {
        name: this.catalogItem.comparisonUnitName,
        minQuantity: this.catalogItem.comparisonUnitMinQuantity,
        maxQuantity: this.catalogItem.comparisonUnitMaxQuantity,
      };
    } else {
      _oldComparisonUnit = null;
    }
    return (this.cloneChoice = null); // reset the "Clone from..." field
  };

  Producer.getProducers().then((producers) => {
    this.producers = producers;
  });

  Supplier.getBySlug($stateParams.supplierSlug)
    .then((supplier) => {
      this.supplier = supplier;
      const catalogItemPromise =
        $stateParams.catalogItemId != null
          ? Catalog.get({id: $stateParams.catalogItemId}).$promise
          : Promise.resolve(
              new Catalog({
                name: '',
                foodhubSlugs: _.compact(
                  supplier.goodeggsLocationIds.map((goodeggsLocationId) => {
                    const foodhubSlug =
                      foodhubHelpers.goodEggsLocationIdsToFoodhubSlug[goodeggsLocationId];
                    if (foodhubSlug == null) {
                      const alert = new KlaxonAlert(
                        `Supplier location id ${goodeggsLocationId} could not be mapped to a foodhub`,
                        {
                          type: 'danger',
                        },
                      );
                      alert.add();
                      return;
                    }
                    return foodhubSlug;
                  }),
                ),
                vendor: {
                  _id: this.supplier.id,
                  slug: this.supplier.slug,
                  name: this.supplier.name,
                },
                irlYield: 1,
                marketProducts: [],
              }),
            );

      return Promise.all([
        catalogItemPromise,
        ProcurementSchedule.query({
          vendorId: this.supplier.id,
          foodhubSlug: $stateParams.foodhubSlug,
        }).$promise,
      ]);
    })

    .finally(() => (this.loading = false))
    .then((...args) => {
      let procurementSchedules;
      [this.catalogItem, procurementSchedules] = Array.from(args[0]);
      this.editing = this.catalogItem._id != null;
      this.procurementSchedule = procurementSchedules[0];
      this.catalogProductStructureType = getCatalogProductStructureType(this.catalogItem);
      this.shouldMigrateToRiversand = shouldMigrateToRiversand(this.catalogItem);

      // we can allow editing some select fields we locked down for the riversand migration
      // based on whether we handle merging related entities in catalog-api
      this.riversandSkuCannotMerge =
        this.catalogProductStructureType === 'non-differentiating' ||
        this.catalogProductStructureType === 'non-fungible';

      this.structureTypesThatAllowAddingMarketProduct = ['non-fungible', 'needs prep'];
      this.structureTypesCannotEditYield = ['non-fungible', 'auto-differentiating'];

      this.migratedToRiversand = Boolean(this.catalogItem.purchasingUomRiversandId);

      this.canEditYield = function(marketProduct) {
        return (
          marketProduct._isNew === true ||
          !this.shouldMigrateToRiversand ||
          !this.structureTypesCannotEditYield.includes(this.catalogProductStructureType)
        );
      };

      this.canAddMarketProduct =
        !this.editing ||
        !this.shouldMigrateToRiversand ||
        this.structureTypesThatAllowAddingMarketProduct.includes(this.catalogProductStructureType);

      this.riversandPurchasingUomLink = `${sites.getUrl(
        'riversand-ui',
        settings,
      )}/entity-manage?id=${this.catalogItem.purchasingUomRiversandId}&type=purchasinguom`;
      this.originalCatalogItem = angular.copy(this.catalogItem);
      if (this.catalogItem.dropoffDayCapacityOverrides == null) {
        this.catalogItem.dropoffDayCapacityOverrides = [];
      }

      if (this.catalogItem.marketProducts != null) {
        this.catalogItem.marketProducts.forEach(
          (marketProduct) =>
            // alias for template to work when editing catalog items
            (marketProduct.product = angular.copy(marketProduct)),
        );
      }

      if (this.catalogItem.isProduce == null) {
        this.catalogItem.isProduce = false;
      }
      if (this.catalogItem.needsPrep == null) {
        this.catalogItem.needsPrep = false;
      }
      if (this.catalogItem.fungible == null) {
        this.catalogItem.fungible = true;
      }

      this.legacyUnitLabel = this.catalogItem.legacyUnitLabel;
      this.catalogItem.legacyUnitLabel = null;

      this.storageTypes = catalogEnums.storageTypes;
      this.storageType = this.catalogItem.storageType;

      this.orderingUnits = catalogEnums.orderingUnits;
      this.comparisonUnits = catalogEnums.comparisonUnits;
      this.packagingFormats = catalogEnums.packagingFormats;
      this.storeByValues = ['each'].concat(catalogEnums.comparisonUnits);
      this.storeByDisabled = this.editing; // Disabled storeBy editing to fix conflicting raw material standard UOMs. See #174392860
      if (this.catalogItem.storeByEach) {
        this.storeBy = 'each';
      } else {
        if (this.catalogItem.comparisonUnitName == null) {
          this.catalogItem.comparisonUnitName = this.comparisonUnits[0];
        }
        this.storeBy = this.catalogItem.comparisonUnitName;
      }
      this.comparisonUnitIsRange = this.catalogItem.comparisonUnitMaxQuantity != null;
      this.catalogItem.unitLabel = helpers.computeCanonicalUnit(
        this.catalogItem != null ? this.catalogItem : {},
      );
      if (this.catalogItem.comparisonUnitMinQuantity == null) {
        this.catalogItem.comparisonUnitMinQuantity = 1;
      }
      if (this.catalogItem.packagedItemQuantity == null) {
        this.catalogItem.packagedItemQuantity = 1;
      }

      ProductTypes.getProductTypes().then((productTypes) => {
        this.productTypes = productTypes;
        if (this.catalogItem.productTypeId != null) {
          return (this.productType = _.find(this.productTypes, {
            id: this.catalogItem.productTypeId,
          }));
        }
      });

      const marketProductsByProducerId = {};

      const populateMarketProducerProducts = function(marketProducer) {
        if (marketProductsByProducerId[marketProducer.id] != null) {
          return Promise.resolve(marketProductsByProducerId[marketProducer.id]);
        }

        // TODO: error handling
        return Product.getFinishedGoodsByProducerId(marketProducer.id).then((marketProducts) => {
          // Yielding virtual market products from a catalog product is not supported by any
          // downstream system, so do not allow it.
          const yieldableMarketProducts = marketProducts.filter(
            ({storageType}) => storageType !== 'virtual',
          );
          marketProductsByProducerId[marketProducer.id] = yieldableMarketProducts;
        });
      };

      this.getSelectableMarketProductsForProducer = function(marketProducer) {
        return marketProductsByProducerId[marketProducer.id].filter(
          (marketProduct) =>
            // don't allow duplicate market products
            !_.some(this.catalogItem.marketProducts, {_id: marketProduct._id}),
        );
      };

      this.selectMarketProducer = (marketProducer, marketProduct) =>
        populateMarketProducerProducts(marketProducer).then(
          () =>
            (marketProduct.producer = {
              id: marketProducer.id,
              name: marketProducer.name,
              slug: marketProducer.slug,
            }),
        );

      this.selectProductType = function(productType) {
        return (this.catalogItem.productTypeId = productType.id);
      };

      this.selectStorageType = function(storageType) {
        return (this.catalogItem.storageType = storageType);
      };

      this.addMarketProduct = function() {
        return this.catalogItem.marketProducts.push({
          name: '',
          _isNew: true,
        });
      };

      this.selectMarketProduct = function(product, marketProduct) {
        marketProduct._id = product._id;
        marketProduct.name = product.name;
        // we only allow active market products on add so hardcoding.
        // this field is needed for catalog item validation logic in purchase-orders-api
        marketProduct.status = 'active';
        marketProduct.unitLabel = product.unit;
      };

      this.removeMarketProduct = function(marketProduct) {
        return _.pull(this.catalogItem.marketProducts, marketProduct);
      };

      this.isProduceDoesntMatchStorageType = function() {
        const anyProduceMarketProducts = _.some(this.catalogItem.marketProducts, [
          'product.storageType',
          'produce',
        ]);
        return this.catalogItem.isProduce !== true && anyProduceMarketProducts;
      };

      // FIXME: Doesn't actually cover all cases.  Individual market products'
      // storageType and productType are lost when saved to the catalog item, so we
      // can't get the full picture when editing...
      this.storageTypeIsntUniform = function() {
        return (
          _(this.catalogItem.marketProducts)
            .map('product')
            .compact()
            .map('storageType')
            .compact()
            .uniq()
            .size() > 1
        );
      };

      // FIXME: Doesn't actually cover all cases.  Individual market products'
      // storageType and productType are lost when saved to the catalog item, so we
      // can't get the full picture when editing...
      this.productTypeIsntUniform = function() {
        return (
          _(this.catalogItem.marketProducts)
            .map('product')
            .compact()
            .map('productType')
            .compact()
            .uniq()
            .size() > 1
        );
      };

      this.allottedShareSumIsValid = function() {
        return helpers.allottedShareSumIsValid(this.catalogItem);
      };

      this.calculationBreakdownForMarketProduct = function(marketProduct) {
        // Ideally this would just check the catalog product's $validity
        // and this market product's $validity, but I can't find a way to do that
        // independently of other market products.
        let result;
        if (
          !_.every([
            marketProduct._id != null,
            marketProduct.yield != null,
            this.catalogItem.unitQuantity != null,
            this.catalogItem.irlYield != null,
            this.catalogItem.fungible || marketProduct.allottedShare != null,
          ])
        ) {
          return '';
        }

        if (this.catalogItem.fungible) {
          result = new BigNumber(this.catalogItem.unitQuantity)
            .times(this.catalogItem.irlYield)
            .dividedBy(marketProduct.yield)
            .integerValue(BigNumber.ROUND_FLOOR);
          return `\
${this.catalogItem.unitQuantity} x ${this.catalogItem.unitLabel} \
x ${new BigNumber(this.catalogItem.irlYield).times(100).toFixed(2)}% / ${marketProduct.yield} \
= ${result}\
`;
        }
        result = new BigNumber(this.catalogItem.unitQuantity)
          .times(this.catalogItem.irlYield)
          .times(marketProduct.allottedShare)
          .dividedBy(marketProduct.yield)
          .integerValue(BigNumber.ROUND_FLOOR);
        return `\
${this.catalogItem.unitQuantity} x ${this.catalogItem.unitLabel} \
x ${new BigNumber(this.catalogItem.irlYield).times(100)}% \
x ${new BigNumber(marketProduct.allottedShare).times(100)}% / ${marketProduct.yield} \
= ${result}\
`;
      };

      this.isEditable = () =>
        employeeRoles.can($rootScope.credentials.google.employee.roles, 'catalog.edit');

      this.isSubmittable = function() {
        return _.every([this.isEditable(), this.allottedShareSumIsValid()]);
      };

      // works with purchase order editing to allow creation while in the process of creating a purchase order line item
      const notifyOpeningWindowOfSave = () => {
        const event = new CustomEvent('catalogProductSave', {
          detail: {catalogItemId: this.catalogItem._id},
        });
        return $window.dispatchEvent(event);
      };

      const save = () => {
        this.catalogItem.updatedBy = $rootScope.credentials.google.email;

        if (!this.editing) {
          this.catalogItem.createdBy = this.catalogItem.updatedBy;
        }

        const success = () => {
          toaster.success('Saved catalog item');
          if ($stateParams.notifyOnSave === 'true') {
            notifyOpeningWindowOfSave();
          }
          if (($window.history != null ? $window.history.length : undefined) > 1) {
            // to accomodate other entry points - eg. procurement schedule editing
            // note that copying and pasting a url into a new chrome window will take you bank to the new chrome window state :(
            // but as bad as that behavior might be, we've decided it's easier to not sweat it as it's not a primary usage
            return $window.history.back();
          }
          return $state.go('catalog.supplier.show');
        };

        return this.catalogItem[this.editing ? '$update' : '$save']().then(
          success,
          toaster.serverFailCB(),
        );
      };

      this.submit = function(e) {
        e.preventDefault(); // don't reload page
        if (this.legacyUnitLabel != null && this.legacyUnitLabel !== this.catalogItem.unitLabel) {
          if (
            !confirm(
              `This change will update the canonical unit from '${this.legacyUnitLabel}' to '${this.catalogItem.unitLabel}'. Continue?`,
            )
          ) {
            return;
          }
        }

        if (!employeeRoles.can($rootScope.credentials.google.employee.roles, 'catalog.edit')) {
          const alert = new KlaxonAlert('You do not have permission to edit.', {type: 'danger'});
          alert.add();
          return;
        }

        if (this.editing && this.shouldMigrateToRiversand) {
          const newCatalogProductStructureType = helpers.getCatalogProductStructureType(
            this.catalogItem,
          );
          if (newCatalogProductStructureType !== this.catalogProductStructureType) {
            const alert = new KlaxonAlert(
              `You may not change the structure of this item from '${this.catalogProductStructureType}' to '${newCatalogProductStructureType}'`,
              {
                type: 'danger',
              },
            );
            alert.add();
            return;
          }
        }

        // clear out incomplete market products
        this.catalogItem.marketProducts = _.filter(
          this.catalogItem.marketProducts,
          (product) => product._id != null,
        );

        const canonicalProduct =
          (this.catalogItem.marketProducts != null
            ? this.catalogItem.marketProducts.length
            : undefined) > 0 && this.catalogItem.marketProducts[0].product != null
            ? this.catalogItem.marketProducts[0].product
            : undefined;

        if (canonicalProduct != null) {
          if (this.catalogItem.productTypeId == null) {
            this.catalogItem.productTypeId = canonicalProduct.productType;
          }
          if (this.catalogItem.storageType == null) {
            this.catalogItem.storageType = canonicalProduct.storageType;
          }
        }

        if (
          (this.catalogItem.unitQuantityLabel != null
            ? this.catalogItem.unitQuantityLabel.length
            : undefined) === 0
        ) {
          this.catalogItem.unitQuantityLabel = null;
        }
        if ((this.catalogItem.sku != null ? this.catalogItem.sku.length : undefined) === 0) {
          this.catalogItem.sku = null;
        }

        for (const marketProduct of Array.from(this.catalogItem.marketProducts)) {
          delete marketProduct.product;
          delete marketProduct._producerDeleteMe;
          delete marketProduct._isNew;
        }

        return save();
      };

      this.deactivate = function() {
        this.catalogItem.status = 'discontinued';
        return save();
      };

      return (this.reactivate = function() {
        this.catalogItem.status = 'active';
        return save();
      });
    });

  return this;
}); // http://stackoverflow.com/questions/28953289/using-controller-as-with-the-ui-router-isnt-working-as-expected

// TODO: Figure out what you can't edit once saved.
// TODO: Editable storageType once market products selected.
